import React from 'react'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {FancyCheckmark} from 'common/FancyCheckmark'
import styles from './AddAnnotationDialog.scss'
import {errorMessage} from 'lib/styleguide/base.scss'
import fetchJSON from 'lib/fetchJSON'
import p from 'prop-types'

export const NEW_ANNOTATION_DIALOG = 'NEW_ANNOTATION_DIALOG'

export class AddAnnotationDialog extends React.PureComponent {
  static propTypes = {
    highlightSlice: p.array,
    onRequestClose: p.func
  }

  constructor (props) {
    super(props)
    this.state = {
      comment: ''
    }
  }

  onInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  saveAnnotation = (e) => {
    const {highlightSlice, route} = this.props
    const {comment} = this.state

    e && e.preventDefault()

    const postData = {
      segment: {
        first_i: highlightSlice[0],
        count: highlightSlice[1] - highlightSlice[0],
        comment: comment
      }
    }

    // TODO: route type is hardcoded in URL until we make RSP work with rides
    this.setState({savePending: true})
    fetchJSON(`/routes/${route.get('id')}/annotate_segment.json`, postData)
      .then(saveResult => this.setState({saveResult, saveError: null, savePending: false}))
      .catch(saveError => this.setState({saveError, saveResult: null, savePending: false}))
  }

  render () {
    const {onRequestClose} = this.props
    const {comment, saveResult, saveError, savePending} = this.state

    return (
      <ConfirmationDialog
        title='Annotate this segment'
        maxWidth='600px'
        confirmText={saveResult ? 'Close' : 'Create'}
        onCancel={onRequestClose}
        onRequestClose={onRequestClose}
        showCancel={!saveResult}
        onConfirm={saveResult ? onRequestClose : this.saveAnnotation}
        confirmPending={savePending}>
        <div className={styles.AddAnnotationDialog}>
          {!saveResult && <form onSubmit={this.saveAnnotation}>
            <p className={styles.lessMargin}>
              An annotation is a way of saving a selection along with a name or comment. You can view the annotations in the left panel to quickly get back to this selection.
            </p>
            <label htmlFor='comment'>Tell us about this stretch </label>
            <input type='text' id='comment' onChange={this.onInputChange} value={comment} name='comment' />
          </form>}
          {saveError && <div className={errorMessage}>
            Oops! There was an error saving that annotation.  Please try again.
          </div>}
          {saveResult && <div className={styles.successMessage}>
            <FancyCheckmark />
            Your annotation was saved.
          </div>}
        </div>
      </ConfirmationDialog>
    )
  }
}
